export const BRAND_NAME = process.env.REACT_APP_WEBSITE_BRAND

export const UPLOAD_RESTRICTIONS = {
  maxFileSizeBytes: 1000 * 1000 * 4.5,
  minFileCount: {
    PRIVATE: {
      identityDocument: 1,
      fiscalCode: 1,
      salarySlips: 2,
      incomeDocuments: 1,
      driversLicense: 1,
      default: 1,
    },
    ENTREPRENEUR: {
      identityDocument: 1,
      fiscalCode: 1,
      salarySlips: 2,
      incomeDocuments: 1,
      driversLicense: 1,
      default: 1,
    },
    BUSINESS: {
      identityDocument: 1,
      incomeDocuments: 1,
      default: 1,
    },
  },
  maxFileCount: {
    PRIVATE: {
      identityDocument: 2,
      fiscalCode: 2,
      salarySlips: 4,
      incomeDocuments: 1,
      driversLicense: 2,
      default: 9,
    },
    ENTREPRENEUR: {
      identityDocument: 2,
      fiscalCode: 2,
      salarySlips: 4,
      incomeDocuments: 1,
      driversLicense: 2,
      default: 9,
    },
    BUSINESS: {
      identityDocument: 2,
      incomeDocuments: 2,
      default: 9,
    },
  },
  allowedFileExtensions: '.jpg,.jpeg,.pdf,.tiff',
  allowedMimeTypes: ['image/jpeg', 'image/tiff', 'application/pdf'],
}

export const CONNECTION_TIMEOUT = 90000
export const ANALYTICS_DELAY = 2000
export const MEDIA_STORAGE_EXPIRATION_DAYS = 30
export const NUMBER_FORMAT = 'it-IT'
export const CURRENCY = 'EUR'
export const INCOMEFREQUENCY = 'YEARLY'
export const INCOMETYPE = 'PERSONAL_INCOME'
export const ANALYTICS_SECTIONS = {
  personalDetails: {
    trackingName: 'Personal data',
  },
  contactDetails: {
    trackingName: 'Contact data',
  },
  paymentDetails: {
    trackingName: 'Bank account details',
  },
  upload: {
    trackingName: 'Document upload',
  },
}

export const ERRORS = {
  TIMEOUT: 'timeout',
  POLLING_ERROR: 'polling error',
  GENERAL: 'general error',
}

export const MAX_POLLING_CYCLES = 60

export const POLLING_INTERVAL = 10000

export const EXIT_URLS = {
  vwfs: 'https://solution.volkswagenleasing.it/it',
  audi: 'https://www.audi.it',
  vwcv: 'https://www.volkswagen-veicolicommerciali.it',
  seat: 'https://www.seat-italia.it',
  skoda: 'https://www.skoda-auto.it',
}

export const STEP = {
  PERSONAL: 'personalDetails',
  CONTACT: 'contactDetails',
  PAYMENT: 'paymentDetails',
  EMPLOYMENT: 'occupationalDetails',
  DOCUMENTS: 'upload',
  SUMMARY: 'summary',
}
